import RoutingService from "./RoutingService";
import EventTypes from "./EventTypes";

module.exports = {
  EventTypes,
  RoutingService: new RoutingService()
};



// WEBPACK FOOTER //
// ./packages/foundation-ui/src/routing/index.js